import { useNavigate } from 'react-router-dom'
/* interface Props{
  name: string
  id_encrypted: string
  insurances :string
  brand: string
} */

const Itemcampaign = ({ name, id_encrypted, insurances, brand}: any) => {
  const navigate = useNavigate()
  return (
    <div className="c-list-campaigns__item">
      <div className="c-list-campaigns__header">
          <img src={brand.pin_logo} alt="logo" className="c-list-campaigns__logo"/>
          <span className="c-list-campaigns__title">{name}</span>
      </div>
      <span className="c-list-campaigns__info">Insurance: {insurances[0] ? insurances[0].insurance : 'Not insurance'}</span>
      <button type="button" className="c-list-campaigns__button" onClick={() => navigate(`${id_encrypted}`)}>VIEW</button>
    </div>
  )
}

export default Itemcampaign